"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_styled_1 = require("./styles.styled");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const helpers_1 = require("../../helpers");
const react_auth_code_input_1 = __importDefault(require("react-auth-code-input"));
const validateOtp_1 = require("../../dataLayer/apisWithoutCache/slr/validateOtp");
const AppContextProvider_1 = require("../../contexts/AppContextProvider");
const cookiesMember_1 = require("../../dataLayer/cookiesAndLocalStorage/cookiesMember");
const theme_1 = require("../../global/theme");
const constants_1 = require("../../constants");
const whatsAppOTP_1 = require("../../dataLayer/apisWithoutCache/slr/whatsAppOTP");
const onKeyPress_1 = __importDefault(require("../../utils/misc/onKeyPress"));
const sendSms_1 = require("../../dataLayer/apisWithoutCache/slr/sendSms");
const viberText_1 = require("../../dataLayer/apisWithoutCache/slr/viberText");
const slrActions_1 = require("../../GTMs/actions/slrActions");
const useTrackPageView_1 = __importDefault(require("../../GTMs/useTrackPageView"));
const loggingTypes_1 = require("../../libs/logging/types/loggingTypes");
const loggingActions_1 = require("../../libs/logging/helpers/loggingActions");
const useScreenLoadLogging_1 = __importDefault(require("../../hooks/useScreenLoadLogging"));
const OtpScreen = () => {
    var _a;
    const { translations, isDesktop, isMobile } = (0, styled_components_1.useTheme)();
    const { flowState, dispatch } = (0, AppContextProvider_1.useSsoContext)();
    // console.log("flowState" , flowState)
    const AuthInputRef = (0, react_1.useRef)(null);
    const [error, setError] = (0, react_1.useState)("");
    const [timeRemaining, setTimeRemaining] = (0, react_1.useState)(60);
    const [enableResend, setEnableResend] = (0, react_1.useState)(false);
    const [optCode, setOtpCode] = (0, react_1.useState)("");
    const handleLoggingScreen = () => {
        const screenNamesMappers = {
            "ACTION_FORGET_PASSWORD": {
                screen: loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION_RESET_PASSWORD_VERIFY
            },
            "ACTION_REGISTRATION": {
                screen: loggingTypes_1.EnumLoggingScreenNames === null || loggingTypes_1.EnumLoggingScreenNames === void 0 ? void 0 : loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION_REGISTER_VERIFY
            },
            "ACTION_EDIT_MOBILE": {
                screen: loggingTypes_1.EnumLoggingScreenNames === null || loggingTypes_1.EnumLoggingScreenNames === void 0 ? void 0 : loggingTypes_1.EnumLoggingScreenNames.ACCOUNT_MOBILE_VERIFY
            }
        };
        return screenNamesMappers[flowState.flow_type];
    };
    const handleLoggingActions = () => {
        var _a, _b, _c;
        switch (flowState.flow_type) {
            case "ACTION_FORGET_PASSWORD":
                return (0, loggingActions_1.authenticateForgetPasswordVerifySubmitAction)({ currentScreen: (_a = handleLoggingScreen()) === null || _a === void 0 ? void 0 : _a.screen });
            case "ACTION_REGISTRATION":
                return (0, loggingActions_1.authenticateRegisterVerifySubmitAction)({ currentScreen: (_b = handleLoggingScreen()) === null || _b === void 0 ? void 0 : _b.screen });
            case "ACTION_EDIT_MOBILE":
                return (0, loggingActions_1.accountChangeMobileVerifySubmitAction)({ memberId: (_c = flowState === null || flowState === void 0 ? void 0 : flowState.memberData) === null || _c === void 0 ? void 0 : _c.id });
        }
    };
    // const {screen} = handleLoggingScreen()
    (0, useTrackPageView_1.default)("slrLoginOTPScreen", true, true);
    (0, useScreenLoadLogging_1.default)((_a = handleLoggingScreen()) === null || _a === void 0 ? void 0 : _a.screen);
    (0, react_1.useEffect)(() => {
        handleVerification()
            .then()
            .catch((e) => {
            if (e.status === 400) {
                dispatch({
                    screenType: constants_1.ScreenConstants.ERROR_SCREEN,
                    errorScreen: {
                        title: e.title,
                        description: e.message,
                        cbTranslation: translations.tryAgain,
                        callBack: () => {
                            dispatch({
                                screenType: (0, helpers_1.getPrevScreen)(flowState.screensFlow, flowState.screenType),
                            });
                        },
                    },
                });
                return;
            }
        });
    }, []);
    (0, react_1.useEffect)(() => {
        let timer;
        if (timeRemaining > 0) {
            timer = setTimeout(() => {
                setTimeRemaining((time) => time - 1);
            }, 1000);
        }
        else {
            setEnableResend(true);
        }
        return () => clearTimeout(timer);
    }, [timeRemaining]);
    (0, react_1.useEffect)(() => {
        const inputElements = document.querySelectorAll("input");
        function handleFocus() {
            if (error)
                setError("");
        }
        inputElements.forEach((input) => {
            input.addEventListener("focus", handleFocus);
        });
        return () => {
            inputElements.forEach((input) => {
                input.removeEventListener("focus", handleFocus);
            });
        };
    }, [error]);
    const handleVerification = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const { flow_type, phone, country } = flowState;
        const countryCode = (_b = country === null || country === void 0 ? void 0 : country.phone_code) === null || _b === void 0 ? void 0 : _b.toString();
        switch (flowState.verificationType) {
            case "whatsApp":
                yield (0, whatsAppOTP_1.postWhatsAppViaOTP)({
                    flow_type,
                    phone_number: phone,
                    country_code: countryCode,
                });
                break;
            case "sms":
                yield (0, sendSms_1.postSendSms)({
                    phone_number: phone,
                    country_code: countryCode,
                    flow_type: flowState.flow_type,
                });
                break;
            case "viber":
                yield (0, viberText_1.postViberText)({
                    phone_number: phone,
                    country_code: countryCode,
                    flow_type: flowState.flow_type,
                });
                break;
        }
    });
    const startTimer = () => __awaiter(void 0, void 0, void 0, function* () {
        if (enableResend === false)
            return;
        yield handleVerification();
        setTimeRemaining(60);
        setEnableResend(false);
    });
    const onSubmitOtpCode = () => __awaiter(void 0, void 0, void 0, function* () {
        var _c, _d, _e;
        try {
            const body = {
                country_code: flowState.country.phone_code,
                otp: optCode,
                phone_number: flowState.phone,
            };
            const response = yield (0, validateOtp_1.postOtpVerification)(body, true);
            console.log("response", response);
            if (response === null || response === void 0 ? void 0 : response.ticket) {
                (0, cookiesMember_1.setTicketCookies)(response.ticket);
            }
            (0, cookiesMember_1.setIdentityCookies)();
            const successScreenData = {
                title: (_c = response === null || response === void 0 ? void 0 : response.success) === null || _c === void 0 ? void 0 : _c.title,
                description: (_d = response === null || response === void 0 ? void 0 : response.success) === null || _d === void 0 ? void 0 : _d.description,
            };
            let screenType = constants_1.ScreenConstants.LOGIN_SUCCESS;
            if (response.member) {
                (0, cookiesMember_1.setMemberCookies)(response.member);
                (0, theme_1.updateThemeMemberData)(response.member);
                if (response.slr_scenario ===
                    constants_1.LoginAndRegistrationOtpActions.ACTION_EDIT_MOBILE) {
                    (0, loggingActions_1.accountChangeMobileSuccessAction)({ memberId: (_e = response === null || response === void 0 ? void 0 : response.member) === null || _e === void 0 ? void 0 : _e.id });
                    screenType = constants_1.ScreenConstants.LOGIN_SUCCESS;
                }
                else if (response.slr_scenario === constants_1.LoginAndRegistrationOtpActions.ACTION_LOGIN) {
                    screenType = response.member.isNewUser ? cookiesMember_1.slrScenario[response.slr_scenario][0] : constants_1.ScreenConstants.LOGIN_SUCCESS;
                }
                else {
                    screenType = cookiesMember_1.slrScenario[response.slr_scenario];
                }
            }
            dispatch({
                screenType,
                memberData: response.member,
                successScreen: successScreenData,
            });
        }
        catch (e) {
            if (e.code === constants_1.ERROR_OTP_WRONG_BY_USER) {
                setError(e.message);
            }
            else if (e.status === 400 && e.code !== constants_1.ERROR_OTP_WRONG_BY_USER) {
                dispatch({
                    screenType: constants_1.ScreenConstants.ERROR_SCREEN,
                    errorScreen: {
                        title: e.title,
                        description: e.message,
                        cbTranslation: translations.tryAgain,
                        callBack: () => {
                            dispatch({
                                screenType: (0, helpers_1.getPrevScreen)(flowState.screensFlow, flowState.screenType),
                            });
                        },
                    },
                });
            }
        }
    });
    (0, onKeyPress_1.default)("Enter", onSubmitOtpCode, null, optCode);
    return ((0, jsx_runtime_1.jsxs)(styles_styled_1.VerificationScreenCont, Object.assign({ id: "successScreen" }, (0, helpers_1.classNames)(isDesktop && "width-460 border radius-8 overflowHidden"), { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({}, (0, helpers_1.classNames)("p-16 whiteBg", isMobile && "pt-0"), { children: [(0, jsx_runtime_1.jsx)("strong", Object.assign({ className: "font-22" }, { children: translations.VerificationCode })), (0, jsx_runtime_1.jsx)("p", Object.assign({ className: "font-14 mt-8" }, { children: translations.VerificationCodeP }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "grayBg p-16 font-17" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "whiteBg fullShadow p-16 mb-16 radius-8" }, { children: [(0, jsx_runtime_1.jsx)(react_auth_code_input_1.default, { allowedCharacters: "numeric", autoFocus: true, onChange: (e) => setOtpCode(e), ref: AuthInputRef, containerClassName: `AuthCodeCont flex alignItems justifyContent ltr ${error ? "validation" : ""}` }), error && ((0, jsx_runtime_1.jsxs)("span", Object.assign({}, (0, helpers_1.classNames)(isDesktop && "ms-32", "mt-16 block font-12 redColor"), { children: ["*", error] }))), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "flex alignItems gap-5 justifyContent mt-32" }, { children: [(0, jsx_runtime_1.jsx)("button", Object.assign({}, (0, helpers_1.classNames)(!enableResend && "darkGrayColor"), { onClick: () => {
                                            startTimer().then();
                                            (0, slrActions_1.gtmResendBtn_SLRLoginOTPScreen)();
                                        } }, { children: translations.resend })), enableResend === false && ((0, jsx_runtime_1.jsxs)("span", { children: [Math.floor(timeRemaining / 60), ":", timeRemaining % 60 < 10 ? "0" : "", timeRemaining % 60, " "] }))] }))] })), (0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: () => {
                            handleLoggingActions();
                            onSubmitOtpCode().then();
                            (0, slrActions_1.gtmContinueBtn_SLRCompleteLoginOTPScreen)();
                        } }, (0, helpers_1.classNames)("blueBtn p-20 font-17", (optCode === null || optCode === void 0 ? void 0 : optCode.length) < 1 && "disabled"), { children: translations.continue }))] }))] })));
};
exports.default = OtpScreen;
